import * as React from "react";
import {translate, Trans} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Container,Row,Col} from "reactstrap";
import InfoBlocks from "../../components/InfoBlocks";
import StatusBar from "../../components/StatusBar";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import moment from "moment";
import timeSlotFormatter from "../../timeSlotFormatter";
import vodafoneLogo from "../../media/icons/vf-logo.png";

class Stage1AppointmentSelect extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        const timeSlot = this.props.ds360APIResult.appointmentTimeSlot;
        const timeSlotText = timeSlotFormatter(timeSlot).text;

		const footerLnk = <TopNav
			buttonTextResource={"footer_link"}
			buttonOnClick={this.props.openTopNav}
		/>;

        return <Container>
            <MobileView>
                <Row>
                    <Col xs={2} style={{marginTop:"15px"}}>
                        <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                    </Col>
                    {footerLnk}
                </Row>
                <StatusBar currentStage={this.props.currentStage} />
                <SpacerRow/>
                <Header
                    textResource={"select_technician_appointment_title"}
                />
                <SpacerRow/>
                <TextBody
                    textResource={"select_technician_appointment_body"}
                />
                <br />
                <TextBody
                    textResource={"select_technician_appointment_body_pt2"}
                />
                <span className={"fixed-to-bottom"}>
                    <InfoBlocks
                        leftTitleResource={"time_window_and_duration"}
                        leftTextResource={"x_o_clock_approx_x_minutes"}
                        time={timeSlotText}
                        duration={"30"}
                        rightTitleResource={"prepare"}
                        rightTextResource={"readable_doorbell_and_basement_sign"}
                    />
                    <BottomBar
                        mainButtonOnClick={this.props.nextStage}
                        mainButtonTextResource={"select_technician_appointment"}
                    />
                </span>
            </MobileView>

            <BrowserView>
                <Row>
                    {footerLnk}
                </Row>
                <StatusBar currentStage={this.props.currentStage} />
                <SpacerRow/>
                <Header
                    textResource={"select_technician_appointment_title"}
                />
                <SpacerRow/>
                <TextBody
                    textResource={"select_technician_appointment_body"}
                />
                <br />
                <TextBody
                    textResource={"select_technician_appointment_body_pt2"}
                />
                <span className={"fixed-to-bottom"}>
                    <InfoBlocks
                        leftTitleResource={"time_window_and_duration"}
                        leftTextResource={"x_o_clock_approx_x_minutes"}
                        time={timeSlotText}
                        duration={"30"}
                        rightTitleResource={"prepare"}
                        rightTextResource={"readable_doorbell_and_basement_sign"}
                    />
                    <BottomBar
                        mainButtonOnClick={this.props.nextStage}
                        mainButtonTextResource={"select_technician_appointment"}
                    />
                </span>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(Stage1AppointmentSelect);